<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="name" clearable placeholder="名称"></el-input>
                        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="name"
                                label="名称"
                                header-align="center"
                                width="250"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="discount"
                                label="折扣(%)"
                                header-align="center"
                                width="250"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="validityDate"
                                label="有效时间"
                                header-align="center"
                                width="250"
                                :formatter="formatterValidityDate"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="sellers"
                                label="设计师"
                                :formatter="formatterSellers"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                                width="230">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                                    <el-button type="text" size="small" @click="remove(scope.row.uuid)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--添加/编辑弹出框-->
        <el-dialog v-loading="loading"
                   :title="title"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   width="800px">
            <div class="dialogBox">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input>
                    </el-form-item>
                    <el-form-item label="折扣比例(%)" prop="discount">
                        <el-input-number v-model="ruleForm.discount" :min="0" :max="100" label="折扣比例">
                        </el-input-number>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="validityDateStart">
                        <el-date-picker type="date" placeholder="选择有效期开始时间" v-model="ruleForm.validityDateStart"
                                        style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="validityDateEnd">
                        <el-date-picker type="date" placeholder="选择有效期结束时间" v-model="ruleForm.validityDateEnd"
                                        style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="选择设计师" prop="sellers">
                        <el-select v-model="ruleForm.sellers"
                                   style="width: 100%"
                                   multiple
                                   filterable
                                   remote
                                   reserve-keyword
                                   @change="changeDesigner"
                                   :remote-method="remoteMethod"
                                   :loading="searchLoading"
                                   placeholder="请搜索设计师">
                            <el-option
                                v-for="item in options"
                                :key="item.userId"
                                :label="item.nickname"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    deleteDiscountSetting,
    designerList,
    getDiscountInfo,
    getDiscountSettingList,
    saveDiscountSetting,
    updateDiscountSetting
} from '../../utils/interface';

export default {
    components: {},
    data() {
        return {
            loading: false,
            tableData: [],
            current:1,
            total: 0,
            pageSize: 8,
            dialogVisible: false,
            title: '',
            name: '',
            searchLoading: false,
            options: [],
            sellers: [],
            ruleForm:{
                name:'',
                validityDate: '',
                discount: '',
                sellers: []
            },
            rules: {
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                discount: [
                    {required: true, message: '请输入折扣比例', trigger: 'blur'}
                ],
                validityDateStart: [{required: true, message: '请选择有效期开始时间', trigger: 'blur'}],
                validityDateEnd: [{required: true, message: '请选择有效期结束时间', trigger: 'blur'}, {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (this.ruleForm.validityDateEnd < this.ruleForm.validityDateStart) {
                            callback(new Error("结束时间不能小于开始时间"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change",
                },],
                sellers: [
                    {required: true, message: '请选择设计师', trigger: 'blur'}
                ],
            },
        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120;
            return {minHeight: height + 'px'}
        },
    },
    created(){
        this.getDiscountSettingList();
    },
    methods: {
        formatterValidityDate(row, column){
            return row.validityDateStart + '至' + row.validityDateEnd;
        },
        formatterSellers(row, column){
            let sellers = '';
            row.sellers.forEach((seller) => {
                sellers += seller.sellerName + ',';
            });
            if(sellers.length > 0) sellers = sellers.substring(0, sellers.length -1)
            return sellers;
        },
        remoteMethod(query) {
            if (query !== '') {
                this.searchLoading = true;
                designerList({nickname:query}).then((res) => {
                    this.searchLoading = false;
                    if (res.success) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.options = [];
            }
        },
        changeDesigner(value) {
        },
        remove(uuid) {
            this.$confirm('确定要删除该折扣设置' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteDiscountSetting(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.searchInfo();
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },
        submitForm(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.ruleForm.type = 'DESIGNER';
                    this.sellers = this.ruleForm.sellers;
                    this.ruleForm.sellers = [];
                    this.sellers.forEach((sellerUuid) => {
                        this.ruleForm.sellers.push({'sellerUuid': sellerUuid});
                    })
                    if(this.type === 'edit') {
                        updateDiscountSetting(this.ruleForm,this.ruleForm.uuid).then((res) => {
                            if (res.success) {
                                this.$message.success("编辑成功");
                                this.dialogVisible = false;
                                this.searchInfo()
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    }else{
                        saveDiscountSetting(this.ruleForm).then((res) => {
                            if (res.success) {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.searchInfo();

                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    }
                    this.type = ''
                }else {
                    this.dialogVisible = true;
                    this.loading = false
                }
            });
        },
        getDiscountSettingList(){
            let params = {
                current:this.current,
                pageSize:this.pageSize,
                name:this.name,
                type: 'DESIGNER'
            };
            getDiscountSettingList(params).then((res)=>{
                this.tableData = res.list;
                this.total = res.total;
                this.pageSize = res.size;
                this.current = res.current;
            });
        },
        searchInfo(){
            this.current = 1;
            this.getDiscountSettingList();
        },
        resetData(){
            this.name = '';
            this.current = 1;
            this.getDiscountSettingList();
        },
        toDialog(type, uuid){
            this.type = type
            this.dialogVisible = true
            this.ruleForm = {
                name: '',
                validityDate: '',
                discount: ''
            }
            this.sellers = [];
            if (type === 'add') {
                this.title = '添加折扣信息'
            } else {
                this.title = '编辑折扣信息'
                getDiscountInfo(uuid).then((res) => {
                    if (res.success) {
                        this.ruleForm = res.data;
                        this.sellers = [];
                        this.options = [];
                        this.ruleForm.sellers.forEach((seller) => {
                            this.sellers.push(seller.sellerUuid);
                            this.options.push({userId:seller.sellerUuid,nickname:seller.sellerName})
                        });
                        this.ruleForm.sellers = this.sellers;
                    }
                });
            }
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getDiscountSettingList();
        },
    }
}
</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;
        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                .timeSearch {
                    background-color: #f2f4f7;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px;
                    margin-right: 30px;
                    border-radius: 8px;

                    span {
                        font-size: 12px;
                        color: #c0c4cc !important;
                        font-weight: normal;
                        padding-left: 15px;
                        margin-right: 5px;
                    }

                    // /deep/ .el-range-input{
                    //         background-color: #f2f4f7;
                    //             &:hover, &:focus {
                    //             background-color: #fff;
                    //             // border: 1px solid #108EE9;
                    //         }
                    // }
                    /deep/ input::-webkit-input-placeholder {
                        color: #c0c4cc;
                        font-size: 12px;
                    }

                    /deep/ .el-range-input:hover {
                        background-color: #fff !important;
                    }

                    /deep/ .el-date-editor .el-range-separator {
                        line-height: 25px;
                        color: #c0c4cc;
                    }

                    /deep/ .el-date-editor .el-range__close-icon {
                        line-height: 28px;
                    }

                    /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                        background-color: white;
                    }

                    /deep/ .el-input__inner {
                        width: 225px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        .el-range-input {
                            background-color: #f2f4f7;
                        }

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;

                        }
                    }
                }
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-input {
                    width: initial;
                    margin-bottom: 22px;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #FFFFFF;
                    margin-bottom:22px;
                }

                .resetBtn {
                    color: #333333;
                    margin-bottom:22px;
                }
            }

        }
    }

    //审核查看详情中title的样式
    /deep/.el-dialog__header{
        border-bottom: 1px solid #ddd;
        .el-dialog__title{
            color: #000;
            font-weight: 700;
            font-size: 16px;

        }
    }
    .dialogBox{
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    // padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                    .two-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            caret-color: rgba(0, 0, 0, 0.65);
                        }
                    }
                }
            }
        }
        .audit{
            padding-bottom: 20px;
            h3{
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                // border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent{
                // padding: 0 30px;
            }
            .cause{
                display: flex;
                margin-top: 20px;
                .causeTitle{
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent{
                    color: #000;
                }
            }
            .auditEnter{
                text-align: center;
                padding-top: 20px;
                button{
                    width: 120px;
                }
            }
        }
    }
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

.tableTool {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;

    .toolRight {
        button {
            width: 83px;
            height: 30px;
            background: rgba(21, 126, 251, 1);
            border: none;
            border-radius: 15px;
            font-size: 13px;
            color: #fff;

            i {
                padding-right: 5px;
            }

            &:hover {
                background: #61a2f0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/discountSetting/discountSetting.vue